import { IconList } from '@sleepstation/components'
import propTypes from '@sleepstation/components-prop-types'
import { SIZE } from '@sleepstation/const'
import PropTypes from 'prop-types'
import { assoc, map } from 'ramda'
import React from 'react'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const addKind = (kind, items) => map(assoc(`type`, kind), items)

const getIconName = (kind) => {
  if (kind === `positive`) {
    return `successAlt`
  }
  if (kind === `defaultBullet`) {
    return `placeholder`
  }
  return `excluded`
}

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FancyList = ({ items, baselines, spacing, kind, iconSize }) => {
  const resolvedItems = addKind(kind, items)
  const iconName = getIconName(kind)

  return (
    <IconList
      iconName={iconName}
      iconSize={iconSize}
      spacing={spacing}
      values={resolvedItems}
      shouldCenterRow={false}
      baselines={baselines}
    />
  )
}

FancyList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  baselines: propTypes.numberOrArrayOfNumbers,
  spacing: propTypes.numberOrArrayOfNumbers,
  kind: PropTypes.string,
  iconSize: PropTypes.string,
}

FancyList.defaultProps = {
  baselines: 1,
  spacing: 0.75,
  kind: `positive`,
  iconSize: SIZE.LARGE,
}

export default FancyList
